import React from 'react';

import DrawerButton from 'components/Views/Creative/Drawers/DrawerButton';
import type Tearsheet from 'stores/Tearsheet';

export interface ViewTearsheetButtonProps {
  tearsheet: Tearsheet;
}

function ViewTearsheetButton({ tearsheet }: ViewTearsheetButtonProps) {
  return (
    <a href={tearsheet.getRoute()}>
      <DrawerButton>View</DrawerButton>
    </a>
  );
}

export default ViewTearsheetButton;
